import { DocumentsQueryParams } from '@adminServices';
import { Document, UpdateDocumentDto } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';
import { PaginationMetadata } from '@shared';

export const ADMIN_DOCUMENTS_ID = '[Documents admin]';

export const loadDocuments = createAction(
  ADMIN_DOCUMENTS_ID + ' Load Documents',
  props<{ params?: DocumentsQueryParams }>(),
);

export const loadDocumentsSuccess = createAction(
  ADMIN_DOCUMENTS_ID + ' Load Documents Success',
  props<{ documents: Document[]; pagination: PaginationMetadata }>(),
);

export const loadDocumentsFailure = createAction(
  ADMIN_DOCUMENTS_ID + ' Load Documents Failure',
  props<{ error: string }>(),
);

export const createDocument = createAction(
  ADMIN_DOCUMENTS_ID + ' Create Document',
  props<{ documentData: CreateDocumentData }>(),
);

export const createDocumentSuccess = createAction(
  ADMIN_DOCUMENTS_ID + ' Create Document Success',
  props<{ document: Document }>(),
);

export const createDocumentFailure = createAction(
  ADMIN_DOCUMENTS_ID + ' Create Document Failure',
  props<{ error: string }>(),
);

export const updateDocument = createAction(
  ADMIN_DOCUMENTS_ID + ' Update Document',
  props<{ id: string; documentData: UpdateDocumentDto; fileSk?: File; fileEn?: File }>(),
);

export const updateDocumentSuccess = createAction(
  ADMIN_DOCUMENTS_ID + ' Update Document Success',
  props<{ document: Document }>(),
);

export const updateDocumentFailure = createAction(
  ADMIN_DOCUMENTS_ID + ' Update Document Failure',
  props<{ error: string }>(),
);

export const deleteDocument = createAction(
  ADMIN_DOCUMENTS_ID + ' Delete Document',
  props<{ id: string }>(),
);

export const deleteDocumentSuccess = createAction(
  ADMIN_DOCUMENTS_ID + ' Delete Document Success',
  props<{ id: string }>(),
);

export const deleteDocumentFailure = createAction(
  ADMIN_DOCUMENTS_ID + ' Delete Document Failure',
  props<{ error: string }>(),
);

export const uploadDocumentFile = createAction(
  ADMIN_DOCUMENTS_ID + ' Upload Document File',
  props<{ id: string; file: File; lang?: DocumentFileLanguage }>(),
);

export const uploadDocumentFileSuccess = createAction(
  ADMIN_DOCUMENTS_ID + ' Upload Document File Success',
  props<{ document: Document }>(),
);

export const uploadDocumentFileFailure = createAction(
  ADMIN_DOCUMENTS_ID + ' Upload Document File Failure',
  props<{ error: string }>(),
);

export const deleteDocumentFile = createAction(
  ADMIN_DOCUMENTS_ID + ' Delete Document File',
  props<{ id: string; lang?: DocumentFileLanguage }>(),
);

export const deleteDocumentFileSuccess = createAction(
  ADMIN_DOCUMENTS_ID + ' Delete Document File Success',
  props<{ document: Document }>(),
);

export const deleteDocumentFileFailure = createAction(
  ADMIN_DOCUMENTS_ID + ' Delete Document File Failure',
  props<{ error: string }>(),
);

export interface CreateDocumentData {
  identifier: string;
  name: string;
  nameEn?: string;
  path?: string;
  pathEn?: string;
  isActive?: boolean;
  file?: File;
  fileEn?: File;
}

export type DocumentFileLanguage = 'sk' | 'en';
